import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/shipment-management',
  component: layout,
  meta: { funcID: 'E0015', PID: 'E00' },
  children: ((pre) => [
    {
      path: 'shipment-orders',
      name: `${pre}shipment-orders`,
      meta: {
        ...meta,
        PID: 'E00',
        funcID: 'E001501',
        head: { back: false },
      },
      component: () =>
        import('@/views/ecom/shipment-management/shipment-orders'),
    },
    {
      path: 'shipment-orders/:pageType/:shipmentCode?',
      name: `${pre}shipment-orders-detail`,
      meta: {
        ...meta,
        PID: 'E00',
        funcID: 'E001501',
        title: ({ $route, menu }) => {
          const shipmentNo = $route.query.shipmentNo
          return [menu?.title, shipmentNo || 'New'].join(' | ')
        },
        pageConfig: {
          layout: {
            class: 'p-0',
            bodyClass: 'p-0 m-0',
          },
        },
      },
      component: () =>
        import('@/views/ecom/shipment-management/shipment-orders/detail'),
    },
  ])('ecom-shipment-management-'),
}
